// extracted by mini-css-extract-plugin
module.exports = {"ad":"StickyAd_ad__1UjQ0","cont":"StickyAd_cont__ADHUc"};